/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ColorPaletteId = {
    Default: 'Default',
    Blue: 'Blue',
    Green: 'Green',
    Purple: 'Purple',
    Teal: 'Teal',
    Pink: 'Pink',
    Amber: 'Amber',
    Indigo: 'Indigo',
    Red: 'Red',
    Cyan: 'Cyan',
    Emerald: 'Emerald',
    Coral: 'Coral',
    Custom: 'Custom'
} as const;
export type ColorPaletteId = typeof ColorPaletteId[keyof typeof ColorPaletteId];


export function instanceOfColorPaletteId(value: any): boolean {
    for (const key in ColorPaletteId) {
        if (Object.prototype.hasOwnProperty.call(ColorPaletteId, key)) {
            if (ColorPaletteId[key as keyof typeof ColorPaletteId] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ColorPaletteIdFromJSON(json: any): ColorPaletteId {
    return ColorPaletteIdFromJSONTyped(json, false);
}

export function ColorPaletteIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColorPaletteId {
    return json as ColorPaletteId;
}

export function ColorPaletteIdToJSON(value?: ColorPaletteId | null): any {
    return value as any;
}

export function ColorPaletteIdToJSONTyped(value: any, ignoreDiscriminator: boolean): ColorPaletteId {
    return value as ColorPaletteId;
}

